import { render, staticRenderFns } from "./DeliveryVitalInfoFrom.vue?vue&type=template&id=046cf384&scoped=true&"
import script from "./DeliveryVitalInfoFrom.vue?vue&type=script&lang=js&"
export * from "./DeliveryVitalInfoFrom.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryVitalInfoFrom.vue?vue&type=style&index=0&id=046cf384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046cf384",
  null
  
)

export default component.exports